/**
 * Source citation schema. PRD-003 DATA-17 + AI-07 + AI-09.
 *
 * Sources are persisted as a row in the `sources` table linked to a task,
 * and also embedded inline on the deliverable for renderer consumption.
 * Agents must not fabricate citations (AI-07); the operator review gate
 * validates that listed please-family sources were actually applied.
 */

import { z } from 'zod';
import { isoTimestampSchema, uuidSchema } from './common.js';
import { sourceTypeSchema } from './enums.js';

export const sourceSchema = z.object({
  type: sourceTypeSchema,
  ref: z.string().min(1), // vault path for please-family, URL for external
  label: z.string().min(1),
});
export type Source = z.infer<typeof sourceSchema>;

/**
 * Source table row. Stored per task; mirrored into deliverables.sources for
 * renderer consumption.
 */
export const sourceRowSchema = z.object({
  id: uuidSchema,
  task_id: uuidSchema,
  type: sourceTypeSchema,
  ref: z.string().min(1),
  label: z.string().min(1),
  created_at: isoTimestampSchema,
});
export type SourceRow = z.infer<typeof sourceRowSchema>;
